import React, { FunctionComponent } from "react"
import { FormControl, OverlayTrigger } from "react-bootstrap"
import RoleAndTemplateManagementHeaderSwitchView from "./RoleAndTemplateManagementHeaderSwitchView/RoleAndTemplateManagementHeaderSwitchView"
import RoleTemplateHashTableBoilerplate from "../utils/boilerPlates/templateBoilerplates/RoleTemplateHashTableBoilerplate"
import searchRolesAndAssignments from "../utils/SearchRolesAndAssignments"
import searchRoleTemplates from "../utils/SearchRoleTemplates"
import ratmService from "../utils/RATMService"
import ratmHash from "../utils/RATMHash"
import ratmTooltip from "../utils/RATMTooltip"
import "./RoleAndTemplateManagementHeader.css"

const RoleAndTemplateManagementHeader: FunctionComponent<{}> = () => {

    const { manageState, state } = ratmService
    const { view, searchInput, firstLoad } = state

    return (
        <div className="RoleAndTemplateManagementHeader">
            <div className={`RoleAndTemplateManagementHeaderBlock RoleAndTemplateManagementHeaderLeft ${firstLoad ? "RoleAndTemplateManagementHeaderLeftHidden" : "RoleAndTemplateManagementHeaderLeftNotHidded"}`}>
                <div className="f838e68cd7de4dd8938bad30ffb71651">
                    <FormControl
                        placeholder={searchInput || `${view === 0 ? "Search roles" : "Search templates"}`}
                        onChange={view === 0 ? searchRolesAndAssignments : searchRoleTemplates}
                        value={searchInput || ""}
                    />
                </div>
            </div>
            <div className="RoleAndTemplateManagementHeaderBlock RoleAndTemplateManagementHeaderMiddle">
                <RoleAndTemplateManagementHeaderSwitchView />
            </div>
            <div className={`RoleAndTemplateManagementHeaderBlock RoleAndTemplateManagementHeaderRight ${firstLoad ? "RoleAndTemplateManagementHeaderRightHidden" : "RoleAndTemplateManagementHeaderRightNotHidded"}`}>
                <OverlayTrigger placement="left" overlay={ratmTooltip(`${view === 0 ? "add a new role" : "add a new template"}`)}>
                    <div
                        className="RoleAndTemplateManagementHeaderBtn"
                        onClick={() => {
                            if (view === 0) {
                                manageState([{ key: "addOrEditRoleId", value: 0 }])
                            } else {
                                manageState([{ key: "addOrEditTemplateId", value: 0 }])
                            }
                        }}
                    >
                        <span className="material-icons bb4a2ec7085f4e5a901c445471e734c7">add</span>
                    </div>
                </OverlayTrigger>
            </div>
        </div>
    )
}

export default RoleAndTemplateManagementHeader